var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "_product-detail-data_",
      staticStyle: { display: "none" },
      attrs: { "data-pid": _vm.productId }
    },
    [
      _c("span", { staticClass: "product-name" }, [_vm._v(_vm._s(_vm.name))]),
      _vm._v(" "),
      _c("span", { staticClass: "product-id" }, [
        _vm._v(_vm._s(_vm.productId))
      ]),
      _vm._v(" "),
      _c("label", { attrs: { for: "quantity-" + _vm.uid } }, [
        _vm._v("quantity")
      ]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.quantity,
              expression: "quantity"
            }
          ],
          staticClass: "quantity-select",
          attrs: { id: "quantity-" + _vm.uid },
          on: {
            change: function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.quantity = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            }
          }
        },
        _vm._l(_vm.product.quantities, function(qty, index) {
          return _c(
            "option",
            {
              key: "quantity-" + _vm.uid + "-" + index,
              attrs: {
                "data-url": _vm.product.productType !== "bundle" ? qty.url : ""
              }
            },
            [_vm._v(_vm._s(qty.value))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._l(_vm.nonSwatchableAttributes, function(attr, index) {
        return _c(
          "div",
          { key: "variation-" + _vm.uid + "-" + attr.id + "-" + index },
          [
            _c(
              "label",
              {
                class: attr.id,
                attrs: { for: attr.id + "-" + _vm.uid + "-" + index }
              },
              [_vm._v(_vm._s(attr.displayName))]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                class: "custom-select form-control select-" + attr.id,
                attrs: { id: attr.id + "-" + _vm.uid + "-" + index }
              },
              [
                _c("option", { domProps: { value: attr.resetUrl } }, [
                  _vm._v(_vm._s(attr.displayName))
                ]),
                _vm._v(" "),
                _vm._l(attr.values, function(attrValue, valIndex) {
                  return _c(
                    "option",
                    {
                      key: attr.id + "-" + _vm.uid + "-" + valIndex,
                      attrs: {
                        "data-attr-value": attrValue.value,
                        disabled: !attrValue.selectable
                      },
                      domProps: {
                        value: attrValue.url,
                        selected: attrValue.selected || attr.values === 1
                      }
                    },
                    [_vm._v(_vm._s(attrValue.displayValue))]
                  )
                })
              ],
              2
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }